import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { 
  Search, 
  Sparkles, 
  Lock, 
  ArrowUpRight, 
  Grid3X3,
  Flame
} from "lucide-react";

/* ===== IMPORT IMAGES ===== */
import dmtImg from "../Assets/ServicesIcon/dmt.png";
import rechargeImg from "../Assets/ServicesIcon/recharge.png";
import aepsImg from "../Assets/ServicesIcon/aeps.png";
import billImg from "../Assets/ServicesIcon/bill.png";
import dthImg from "../Assets/ServicesIcon/dth.png";
import fastagImg from "../Assets/ServicesIcon/fastag.png";
import ppiImg from "../Assets/ServicesIcon/ppi.png";
import creditcard from "../Assets/ServicesIcon/credit.png";
import travel from "../Assets/ServicesIcon/travel.png";
import pg from "../Assets/ServicesIcon/pg.png";
import cms from "../Assets/ServicesIcon/cms.png";
import upiCwImg from "../Assets/ServicesIcon/upiCash.png";
import verification from "../Assets/ServicesIcon/verification.jpeg";
import indonepal from "../Assets/ServicesIcon/indonepal.png";
import bbpsMnemonicImg from "../Assets/Images/bbps-mnemonic.svg";
import aadhaarPayImg from "../Assets/ServicesIcon/aeps.png";
import bill from "../Assets/ServicesIcon/bill.jpeg";
import gas from "../Assets/ServicesIcon/gas.jpeg";
import insurance from "../Assets/ServicesIcon/insurancew.jpeg";

/* ===== SERVICES CONFIGURATION ===== */
const services = [
  {
    name: "DMT",
    // category: "Banking",
    view: "dmtservices",
    key: "isDmtEnabled",
    image: dmtImg,
    disabled: false,
    // badge: "Popular",
  },
  {
    name: "RECHARGE",
    // category: "Utility",
    view: "selectedopt",
    key: "isRechargeEnabled",
    image: rechargeImg,
    disabled: false,
  },
  {
    name: "AEPS",
    // category: "Banking",
    view: "aeps",
    key: "isAepsEnabled",
    image: aepsImg,
    disabled: false,
    // badge: "High Margin",
  },
  {
    name: "BBPS ONLINE",
    // category: "Bill Pay",
    view: "rbservices",
    key: "isBbpsEnabled",
    image: bbpsMnemonicImg,
    disabled: false,
  },
  {
    name: "Electricity Bill",
    // category: "Bill Pay",
    view: "electricitybillpay",
    key: "isElectricityBillPayEnabled",
    image: bill,
    disabled: false,
  },
  // {
  //   name: "Gas Bill",
  //   // category: "Bill Pay",
  //   view: "gasbillpay",
  //   key: "isElectricityBillPayEnabled",
  //   image: gas,
  //   disabled: false,
  // },
  {
    name: "Insurance",
    // category: "Financial",
    view: "insurance",
    key: "isElectricityBillPayEnabled",
    image: insurance,
    disabled: false,
  },
  {
    name: "DTH",
    // category: "Utility",
    view: "dth",
    key: "isDTHEnabled",
    image: dthImg,
    disabled: false,
  },
  {
    name: "CREDIT BILL PAY",
    // category: "Financial",
    view: "ccbp",
    key: "isCcbpEnabled",
    image: creditcard,
    disabled: false,
  },
  {
    name: "CMS",
    // category: "Banking",
    view: "cms",
    key: "isCMSEnabled",
    image: cms,
    disabled: false,
  },
  {
    name: "UPI CashWithdraw",
    view: "upicashout",
    key: "isUpiCwEnabled",
    image: upiCwImg,
    disabled: false,
    forceEnable: true,
  },
  {
    name: "PPI",
    // category: "Cards",
    view: "ppimain",
    key: "isPpiEnabled",
    image: ppiImg,
    disabled: false,
  },
  {
    name: "FASTAG",
    // category: "Travel",
    view: "fastag",
    key: "isFastagEnabled",
    image: fastagImg,
    disabled: false,
  },
 
  {
    name: "FLIGHTS",
    view: "flight-search",
    key: "isTravelEnabled",
    image: travel,
    disabled: false,
    forceEnable: true,
  },
  {
    name: "Verification",
    // category: "KYC",
    view: "verification",
    key: "isVerificationEnabled",
    image: verification,
    forceEnable: true,
  },
  {
    name: "Indo Nepal",
    // category: "Remittance",
    view: "indonepal",
    key: "isVerificationEnabled",
    image: indonepal,
    disabled: false,
    forceEnable: true,
  },
  {
    name: "Aadhaar Pay",
    // category: "Banking",
    view: "aadhaarpaydashboard",
    key: "isAadhaarPayEnabled",
    image: aadhaarPayImg,
    forceEnable: true,
  },
   {
    name: "PG",
    // category: "Payment",
    view: "pg",
    key: "isPgInEnabled",
    image: pg,
    // disabled: true,
  },
  //  {
  //   name: "PPI",
  //   // category: "Cards",
  //   view: "ppi",
  //   key: "isPpiEnabled",
  //   image: ppiImg,
  //   disabled: true,
  // },
];

const ServiceHub = () => {
  const navigate = useNavigate();
  const reduxdata = useSelector((s) => s.auth.employeeDetails) || {};
  const [searchTerm, setSearchTerm] = useState("");

  const username = useSelector((state) => state.auth?.employeeDetails?.username);
  const role = useSelector((state) => state.auth?.employeeDetails?.role);

  const hideDmtAeps = username === "sou4276_2330" && role === "MERCHANT";

  const filteredServices = services.filter((s) => {
    if (hideDmtAeps && (s.name === "DMT" || s.name === "AEPS")) return false;
    return s.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="w-full space-y-6">
      {/* Header & Search Bar */}
      {/* <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 pb-4">
        <div className="flex items-center gap-2.5">
          <div className="p-2 rounded-xl bg-blue-50 text-blue-600 border border-blue-100">
            <Grid3X3 className="w-4 h-4" />
          </div>
          <div>
            <h3 className="text-base font-bold text-slate-800">
              Services & Portals
            </h3>
            <p className="text-xs text-slate-400 font-medium">
              Quick access to merchant utilities and banking channels
            </p>
          </div>
        </div>

        <div className="relative w-full sm:w-64">
          <Search className="w-3.5 h-3.5 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Search service..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-3.5 py-2 bg-slate-50 hover:bg-slate-100/80 focus:bg-white border border-slate-200/80 focus:border-blue-500 rounded-xl text-xs text-slate-700 placeholder-slate-400 transition outline-hidden"
          />
        </div>
      </div> */}

      {/* Services Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3.5 sm:gap-4">
        {filteredServices.map((service) => {
          const enabled =
            !service.disabled &&
            (reduxdata?.[service.key] === true || service.forceEnable === true);

          return (
            // <div
            //   key={service.name}
            //   onClick={() => {
            //     if (!enabled) return;
            //     navigate(`/${service.view}`);
            //   }}
            //   className={`
            //     group relative flex flex-col items-center justify-between p-4 rounded-2xl border transition-all duration-200 select-none
            //     ${
            //       enabled
            //         ? "bg-white border-slate-200/80 hover:border-blue-300 hover:shadow-lg hover:shadow-blue-900/5 hover:-translate-y-1 cursor-pointer active:scale-95"
            //         : "bg-slate-50/60 border-slate-200/40 opacity-50 cursor-not-allowed grayscale"
            //     }
            //   `}
            // >
            <div
              key={service.name}
              onClick={() => {
                if (!enabled) return;
                navigate(`/${service.view}`);
              }}
              className={`
                group relative flex flex-col items-center justify-between p-4 rounded-2xl transition-all duration-300 select-none
                ${
                  enabled
                    /* 🎨 CHANGED: Permanent Gold Gradient, thicker 5px 3D lip, and massive shadows */
                    ? " border border-amber-200 border-b-[5px] border-b-amber-400 shadow-[0_8px_20px_rgba(0,0,0,0.12)] hover:shadow-[0_16px_32px_rgba(217,119,6,0.25)] hover:border-amber-300 hover:border-b-amber-500 hover:-translate-y-2 cursor-pointer active:scale-95"
                    : "bg-slate-50 border border-slate-200/60 opacity-50 cursor-not-allowed grayscale shadow-none"
                }
              `}
            >
              {/* Optional Top Badge / Status */}
              <div className="w-full flex items-center justify-between mb-2">
                {service.badge ? (
                  <span className="inline-flex items-center gap-0.5 text-[9px] font-bold px-1.5 py-0.5 rounded-md bg-blue-50 text-blue-600 border border-blue-100">
                    <Flame className="w-2.5 h-2.5 text-amber-500 fill-amber-500" />
                    {service.badge}
                  </span>
                ) : (
                  <span />
                )}

                {/* Lock or Arrow icon indicator */}
                {!enabled ? (
                  <Lock className="w-3 h-3 text-slate-400 ml-auto" />
                ) : (
                  <ArrowUpRight className="w-3 h-3 text-slate-300 group-hover:text-blue-600 transition-colors ml-auto" />
                )}
              </div>

              {/* Service Icon Container */}
              {/* <div className="relative w-16 h-16 sm:w-18 sm:h-18 flex items-center justify-center rounded-2xl bg-slate-50/80 group-hover:bg-blue-50/40 p-2.5 transition-all">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-contain drop-shadow-xs transition-transform duration-300 group-hover:scale-110"
                />
              </div> */}

              {/* Service Icon Container */}
<div className="relative w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center rounded-2xl bg-slate-50/80 group-hover:bg-blue-50/40 p-1.5 transition-all">
  <img
    src={service.image}
    alt={service.name}
    className="w-full h-full object-contain drop-shadow-sm transition-transform duration-300 group-hover:scale-110"
  />
</div>

              {/* Service Label */}
              <div className="mt-3 text-center w-full">
                <p className="text-xs font-bold text-slate-800 tracking-tight line-clamp-1 group-hover:text-blue-600 transition-colors">
                  {service.name}
                </p>
                {/* <p className="text-[10px] text-slate-400 font-medium mt-0.5">
                  {service.category || "Service"}
                </p> */}
              </div>
            </div>
          );
        })}

        {filteredServices.length === 0 && (
          <div className="col-span-full py-12 text-center text-slate-400 text-xs">
            No service found matching "<b>{searchTerm}</b>"
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceHub;